import React from 'react'
import "./Loading.css"

const Loading = () => {
    return (
        <div className="loadingio-spinner-spin-j0h89mbuyk">
            <div className="ldio-0n453coy2pyp">
                <div><div></div></div>
                <div><div></div></div>
                <div><div></div></div>
                <div><div></div></div>
                <div><div></div></div>
                <div><div></div></div>
                <div><div></div></div>
                <div><div></div></div>
            </div>
        </div>
    )
}

export default Loading